<ng-template #tyhjaTila>
  <div class="tyhja-tila">
    <span class="pokaali">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="#F9A825">
        <path d="M5 3h14v2h3v3c0 2.5-2 4.5-4.5 4.9A6 6 0 0 1 13 16.9V19h3v2H8v-2h3v-2.1a6 6 0 0 1-4.5-3.9C4 12.5 2 10.5 2 8V5h3V3zm-1 4v1c0 1.4 1 2.6 2.2 2.9A6 6 0 0 1 6 8V7H4zm16 0h-2v1c0 1-.1 2-.2 2.9C19 10.6 20 9.4 20 8V7z"></path>
      </svg>
      <svg class="tahti-iso" width="14" height="14" viewBox="0 0 24 24" fill="#FDD835">
        <path d="M12 2l2.4 6.9H21l-5.7 4.2 2.2 6.9-5.5-4.2-5.5 4.2 2.2-6.9L3 8.9h6.6z"></path>
      </svg>
      <svg class="tahti-pieni" width="9" height="9" viewBox="0 0 24 24" fill="#FDD835">
        <path d="M12 2l2.4 6.9H21l-5.7 4.2 2.2 6.9-5.5-4.2-5.5 4.2 2.2-6.9L3 8.9h6.6z"></path>
      </svg>
    </span>
    <span class="tyhja-teksti">Kaikki tehty, hienoa!</span>
  </div>
</ng-template>

@if (kortit()) {
  <div class="korttirivi">
    @for (kortti of naytettavatKortit(); track kortti.tyyppi) {
      <div class="kortti" role="group" [attr.aria-label]="kortti.otsikko">
        <div class="kortin-otsikko">
          <span class="otsikkoluku" [class.nolla]="kortti.yhteensa === 0">{{ kortti.yhteensa }}</span>
          <div class="otsikkoteksti">{{ kortti.otsikko }}</div>
        </div>
        <div class="erotin"></div>
        @if (kortti.rivit.length) {
          <div class="rivit">
            @for (rivi of kortti.rivit; track rivi.suodatus.rivinAvain) {
              <div class="rivi" role="button" tabindex="0" [class.myohassa]="rivi.tila === 'myohassa'" [class.eraantyy]="rivi.tila === 'eraantyy'" [class.aktiivinen]="rivi.aktiivinen" [attr.aria-pressed]="rivi.aktiivinen" [matTooltip]="rivi.vihje" (click)="valitseKohde(rivi)" (keydown.enter)="valitseKohde(rivi)">
                <span class="rivin-nimi">{{ rivi.nimi }}</span>
                @if (rivi.erapaivaTeksti) {
                  <span class="erapaiva">{{ rivi.erapaivaTeksti }}</span>
                }
                <span class="tayte"></span>
                @if (rivi.kirjauksia !== null) {
                  <span class="asiakasmaara">{{ rivi.asiakasmaaraTeksti }}</span>
                  <span class="kirjauspallo">{{ rivi.kirjauksia }}</span>
                } @else {
                  <span class="luku">{{ rivi.maara }}</span>
                }
              </div>
            }
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="tyhjaTila"></ng-container>
        }
      </div>
    }

    <div class="kortti" role="group" aria-label="Tilinpäätöstä tehtävänä">
      <div class="kortin-otsikko">
        <span class="otsikkoluku" [class.nolla]="tilinpaatostenYhteensa() === 0">{{ tilinpaatostenYhteensa() }}</span>
        <div class="otsikkoteksti">Tilinpäätöstä tehtävänä</div>
      </div>
      <div class="erotin"></div>
      @if (tilinpaatosrivit().length) {
        <div class="tilinpaatosruudukko tilinpaatoksen-otsikot">
          <span class="jakson-otsikko">Tilikauden päättymiskk</span>
          <span class="vaiheiden-otsikot">
            @for (vaihe of tilinpaatoksenVaiheet; track vaihe.vaihe) {
              <span>{{ vaihe.nimi }}</span>
            }
          </span>
          <span class="osinkojen-otsikko">Osingot ilmoittamatta</span>
        </div>
        <div class="tilinpaatosrivit">
          @for (rivi of tilinpaatosrivit(); track rivi.avain) {
            <div class="tilinpaatosruudukko tilinpaatosrivi">
              <div class="tilinpaatoksen-jakso">
                <span class="rivin-nimi">{{ rivi.nimi }}</span>
                <span class="erapaiva">{{ rivi.erapaivaTeksti }}</span>
              </div>
              <div class="vaihenuolet">
                @for (nuoli of rivi.nuolet; track nuoli.sijainti) {
                  <span
                    class="vaihenuoli"
                    [class]="nuoli.sijainti"
                    [class.tyhja]="nuoli.maara === 0"
                    [class.klikattava]="nuoli.maara > 0"
                    [class.myohassa]="nuoli.tila === 'myohassa'"
                    [class.eraantyy]="nuoli.tila === 'eraantyy'"
                    [class.aktiivinen]="nuoli.aktiivinen"
                    [attr.role]="nuoli.maara > 0 ? 'button' : null"
                    [attr.tabindex]="nuoli.maara > 0 ? 0 : null"
                    [attr.aria-pressed]="nuoli.maara > 0 ? nuoli.aktiivinen : null"
                    [matTooltip]="nuoli.vihje"
                    (click)="valitseKohde(nuoli)"
                    (keydown.enter)="valitseKohde(nuoli)"
                  >
                    <b>{{ nuoli.maara || '–' }}</b>
                  </span>
                }
              </div>
              <div class="osingot">
                @if (rivi.osingot.maara > 0) {
                  <span class="osinkoluku" role="button" tabindex="0" [class.myohassa]="rivi.osingot.tila === 'myohassa'" [class.eraantyy]="rivi.osingot.tila === 'eraantyy'" [class.aktiivinen]="rivi.osingot.aktiivinen" [attr.aria-pressed]="rivi.osingot.aktiivinen" [matTooltip]="rivi.osingot.vihje" (click)="valitseKohde(rivi.osingot)" (keydown.enter)="valitseKohde(rivi.osingot)">{{
                    rivi.osingot.maara
                  }}</span>
                } @else {
                  <span class="osinkoluku-tyhja">–</span>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="tyhjaTila"></ng-container>
      }
    </div>
  </div>
} @else {
  <div class="korttirivi" aria-busy="true" aria-label="Ladataan yhteenvetokortteja">
    @for (kortti of luurankokortit; track kortti) {
      <div class="kortti">
        <div class="kortin-otsikko">
          <span class="luuranko luuranko-luku"></span>
          <span class="luuranko luuranko-otsikko"></span>
        </div>
        <div class="erotin"></div>
        @for (rivi of luurankorivit; track rivi) {
          <span class="luuranko luuranko-rivi"></span>
        }
      </div>
    }
  </div>
}
